<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 ma-0 pa-0 text-xs-center headline font-weight-bold>
        <p style="min-height: 450px;">Page Not Found</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>